import { useEffect } from 'react';
import { toast } from 'sonner';
import type { ClientError } from '@/lib/error-store';

/**
 * Listens for client errors and shows toast notifications.
 * Mount once at app root level.
 */
export function ErrorNotifier() {
  useEffect(() => {
    const handler = (e: Event) => {
      const error = (e as CustomEvent<ClientError>).detail;
      if (!error) return;

      // Only show toast for actual errors, not warnings
      if (error.level === 'warning') return;

      // Truncate long messages
      const msg = error.message.length > 120
        ? error.message.slice(0, 120) + '…'
        : error.message;

      toast.error(msg, {
        description: error.source || error.category || undefined,
        duration: 5000,
        action: {
          label: 'View Logs',
          onClick: () => { window.location.href = '/settings?tab=errors'; },
        },
      });
    };

    window.addEventListener('pm-error-update', handler);
    return () => window.removeEventListener('pm-error-update', handler);
  }, []);

  return null;
}
